/**
 * Zwei-Finger-Zoom im Mailtext (Handy). Der Seiten-Zoom ist auf iOS seit
 * #2395 aus (maximum-scale=1, kein Auto-Zoom bei Eingaben) — gezoomt wird
 * deshalb nur der Mailtext selbst, wie in Outlook iOS optisch (ohne Umbruch)
 * mit seitlichem Verschieben. Rein, damit testbar.
 */
export const ZOOM_MIN = 1;
export const ZOOM_MAX = 3;

/** Neuer Zoom aus dem Abstand der beiden Finger (Start → jetzt), begrenzt auf 1–3×. */
export function naechsterZoom(zoomStart: number, abstandStart: number, abstand: number): number {
    if (!(abstandStart > 0) || !(abstand > 0)) return zoomStart;
    const z = zoomStart * (abstand / abstandStart);
    return Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, Math.round(z * 100) / 100));
}

/** Abstand zweier Berührungspunkte. */
export function fingerAbstand(a: { clientX: number; clientY: number }, b: { clientX: number; clientY: number }): number {
    return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
}

/**
 * Seitliche Scroll-Position nach einem Zoomschritt, damit die Stelle zwischen
 * den Fingern stehen bleibt. `x` = Position im ungezoomten Mailtext.
 */
export function scrollNachZoom(scrollLeft: number, x: number, zoomVorher: number, zoomNachher: number): number {
    return Math.max(0, scrollLeft + x * (zoomNachher - zoomVorher));
}

/** Zwei kurze Tipps kurz hintereinander, fast an derselben Stelle. */
export function istDoppeltipp(
    vorher: { zeit: number; x: number; y: number } | null,
    jetzt: { zeit: number; x: number; y: number },
): boolean {
    return !!vorher && jetzt.zeit - vorher.zeit < 320 && Math.hypot(jetzt.x - vorher.x, jetzt.y - vorher.y) < 30;
}
